var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 2800,
    transform: "translate(-928 -112)",
    fill: "#var(--background-dark)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dropdown",
    d: "M8.5 15L0.272758 0.75H16.7272L8.5 15Z",
    fill: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.5ef87c7d2860a4f643d4171d59b8d3b8.svg";
export { ForwardRef as ReactComponent };